import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { BRAZO_INFO } from '../../config';
import { getImageUrl } from '../../utils/imageUtils';

const OrderDialog = ({
  orderDialog,
  setOrderDialog,
  selectedProduct,
  productType,
  selectedSize,
  setSelectedSize,
  selectedFlavors,
  customQuantity,
  setCustomQuantity,
  setSelectedFlavors,
  galletas,
  handleFlavorChange,
  getTotalSelectedFlavors,
  calculateCustomPrice,
  addToCart
}) => {
  return (
    <Dialog open={orderDialog} onOpenChange={setOrderDialog}>
      <DialogContent className="sm:max-w-md max-h-[85vh] h-auto flex flex-col overflow-hidden">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>Agregar {selectedProduct?.name}</DialogTitle>
          <DialogDescription>
            Selecciona el tamaño que deseas ordenar
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2 overflow-y-auto flex-1 min-h-0">
          {productType === 'brazo' && (
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-3">
              <div className="flex items-center space-x-2 mb-2">
                <div className="text-2xl">📏</div>
                <div>
                  <p className="font-semibold text-chocolate text-sm">Tamaño del Brazo Completo:</p>
                  <p className="text-xs text-chocolate-light">{BRAZO_INFO.description}</p>
                </div>
              </div>
              <div className="text-center">
                <div className="inline-flex items-center space-x-2 bg-white px-3 py-1.5 rounded-full shadow-sm">
                  <span className="text-xs text-chocolate-light">Rinde:</span>
                  <span className="text-lg font-bold text-caramel">10-12</span>
                  <span className="text-xs text-chocolate-light">porciones</span>
                </div>
              </div>
            </div>
          )}

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-2">
            <p className="text-xs font-semibold text-amber-900">⚠️ {productType === 'brazo' ? 'Porciones sujetas a disponibilidad. Algunos sabores requieren 2h.' : 'Sabores sujeto a disponibilidad'}</p>
          </div>

          <RadioGroup value={selectedSize} onValueChange={setSelectedSize} className="space-y-2.5">
            {productType === 'brazo' ? (
              <div className="space-y-2.5">
                {selectedProduct?.availableSlice !== false && (
                  <label className={`flex items-start space-x-3 p-3 border-2 rounded-lg transition-all cursor-pointer min-h-[60px] w-full ${selectedSize === 'slice' ? 'border-[#4a2c2a] bg-[#4a2c2a]/5 shadow-md' : 'border-gray-200 hover:border-caramel'}`}>
                    <RadioGroupItem value="slice" id="slice" className="flex-shrink-0 mt-1" />
                    <div className="flex-grow">
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                        <div>
                          <div className="font-semibold text-sm leading-5">Porción Individual</div>
                          <div className="text-xs text-chocolate-light">Perfecto para probar</div>
                        </div>
                        <div className="text-lg font-bold text-caramel">
                          ${selectedProduct?.priceSlice?.toFixed(2) || '0.00'}
                        </div>
                      </div>
                    </div>
                  </label>
                )}
                {selectedProduct?.availableFull !== false && (
                  <label className={`flex items-start space-x-3 p-3 border-2 rounded-lg transition-all cursor-pointer min-h-[60px] w-full ${selectedSize === 'full' ? 'border-[#4a2c2a] bg-[#4a2c2a]/5 shadow-md' : 'border-gray-200 hover:border-caramel'}`}>
                    <RadioGroupItem value="full" id="full" className="flex-shrink-0 mt-1" />
                    <div className="flex-grow">
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                        <div>
                          <div className="font-semibold text-sm leading-5">Brazo Completo ({BRAZO_INFO.length})</div>
                          <div className="text-xs text-chocolate-light">{BRAZO_INFO.servings}</div>
                        </div>
                        <div className="text-lg font-bold text-caramel">
                          ${selectedProduct?.priceFull?.toFixed(2) || '0.00'}
                        </div>
                      </div>
                    </div>
                  </label>
                )}
                {selectedProduct?.availableSlice === false && selectedProduct?.availableFull === false && (
                  <div className="text-center py-4 text-red-600">
                    <p className="font-semibold text-sm">Este producto no está disponible actualmente</p>
                  </div>
                )}
              </div>
            ) : productType === 'galleta' ? (
              <div className="text-center py-4">
                <div className="text-2xl font-bold text-caramel mb-2">
                  ${selectedProduct?.priceUnit?.toFixed(2) || '1.50'}
                </div>
                <p className="text-sm text-chocolate-light">Precio por unidad</p>
              </div>
            ) : (productType === 'pack' || productType === 'fixed' || productType === 'custom') ? (
              <div className="flex flex-col space-y-4 w-full">
                {productType === 'custom' && (
                  <div className="w-full bg-amber-50 border-2 border-caramel rounded-lg p-4">
                    <label className="block text-base font-semibold text-chocolate mb-2 text-center">
                      1️⃣ Cantidad de Galletas
                    </label>
                    <p className="text-xs text-chocolate-light mb-3 text-center">
                      13-48: $1.17 c/u | 49+: $1.10 c/u
                    </p>
                    <div className="flex items-center justify-center space-x-4">
                      <button
                        type="button"
                        onClick={() => {
                          const newQty = Math.max(13, customQuantity - 1);
                          setCustomQuantity(newQty);
                          setSelectedFlavors({});
                        }}
                        className="w-12 h-12 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center font-bold text-xl"
                      >-</button>
                      <input
                        type="number"
                        min="13"
                        max="100"
                        value={customQuantity}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '') {
                            setCustomQuantity(13);
                          } else {
                            const num = parseInt(val, 10);
                            if (!isNaN(num)) {
                              setCustomQuantity(Math.max(13, Math.min(100, num)));
                            }
                          }
                          setSelectedFlavors({});
                        }}
                        onFocus={(e) => e.target.select()}
                        className="w-20 border-2 border-caramel rounded-lg p-2 text-center text-xl font-bold"
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const newQty = Math.min(100, customQuantity + 1);
                          setCustomQuantity(newQty);
                          setSelectedFlavors({});
                        }}
                        className="w-12 h-12 rounded-full bg-[#4a2c2a] hover:bg-[#3a1c1a] text-white flex items-center justify-center font-bold text-xl"
                      >+</button>
                    </div>
                  </div>
                )}
                
                <div className="w-full bg-cream border-2 border-caramel rounded-lg p-4">
                  <div className="flex justify-between items-center mb-3">
                    <span className="font-semibold text-chocolate">
                      {productType === 'custom' ? '2️⃣' : '1️⃣'} Selecciona tus sabores:
                    </span>
                    <span className={`text-sm font-bold px-3 py-1 rounded-full ${getTotalSelectedFlavors() === (productType === 'custom' ? customQuantity : selectedProduct?.quantity) ? 'bg-green-600 text-white' : 'bg-amber-200 text-amber-800'}`}>
                      {getTotalSelectedFlavors()} / {productType === 'custom' ? customQuantity : selectedProduct?.quantity}
                    </span>
                  </div>
                  
                  <div className="grid grid-cols-1 gap-2 max-h-64 overflow-y-auto">
                    {galletas.map((galleta) => (
                      <div key={galleta.id} className="flex items-center justify-between bg-white p-2 rounded-lg">
                        <div className="flex items-center space-x-2">
                          <img 
                            src={getImageUrl(galleta.image)} 
                            alt={galleta.name} 
                            className="w-10 h-10 rounded-full object-cover"
                          />
                          <span className="text-sm font-medium">{galleta.name}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <button
                            type="button"
                            onClick={() => handleFlavorChange(galleta.id, Math.max(0, (selectedFlavors[galleta.id] || 0) - 1))}
                            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center font-bold"
                          >-</button>
                          <span className="w-8 text-center font-bold">{selectedFlavors[galleta.id] || 0}</span>
                          <button
                            type="button"
                            onClick={() => {
                              const maxQty = productType === 'custom' ? customQuantity : selectedProduct?.quantity;
                              if (getTotalSelectedFlavors() < maxQty) {
                                handleFlavorChange(galleta.id, (selectedFlavors[galleta.id] || 0) + 1);
                              }
                            }}
                            className="w-8 h-8 rounded-full bg-caramel hover:bg-amber-600 text-white flex items-center justify-center font-bold"
                          >+</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="w-full bg-[#4a2c2a] text-white rounded-lg p-5 text-center">
                  <p className="text-sm mb-1 opacity-90">
                    {productType === 'custom' ? '3️⃣' : '2️⃣'} Total a pagar:
                  </p>
                  <p className="text-4xl font-bold">
                    ${productType === 'custom' ? calculateCustomPrice().toFixed(2) : selectedProduct?.price?.toFixed(2) || '0.00'}
                  </p>
                  {productType === 'custom' && customQuantity > 0 && (
                    <p className="text-xs mt-2 opacity-75">
                      {customQuantity} galletas × ${(calculateCustomPrice() / customQuantity).toFixed(2)} c/u
                    </p>
                  )}
                </div>
              </div>
            ) : null}
          </RadioGroup>
        </div>
        <DialogFooter className="gap-2 flex-shrink-0 border-t pt-4 mt-2">
          <Button
            onClick={addToCart}
            className="flex-1 bg-[#4a2c2a] hover:bg-[#3a1c1a] text-white shadow-lg hover:shadow-xl transition-all duration-200"
            size="lg"
          >
            Agregar al Pedido
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OrderDialog;
